export type BuildSignupUrlInput = {
  baseUrl: string
  sourceId?: string
  redirectUrl: string
}

export function buildSignupUrl({
  baseUrl,
  sourceId,
  redirectUrl,
}: BuildSignupUrlInput): string {
  const url = new URL(baseUrl)

  url.searchParams.set('source_app', 'mtag')
  url.searchParams.set('redirect_url', redirectUrl)

  if (sourceId) {
    url.searchParams.set('source_id', sourceId)
  }

  return url.toString()
}
